import { WEEKDAYS } from 'my-phorest/utils/local-date-helpers';

export function weekStartDay(branch) {
  const weekStartDay = branch?.weekStartDay || 'SUNDAY';
  return WEEKDAYS.indexOf(weekStartDay);
}
